import { render, staticRenderFns } from "./channels-listing.vue?vue&type=template&id=4fc3a3b8&scoped=true&"
import script from "./channels-listing.vue?vue&type=script&lang=js&"
export * from "./channels-listing.vue?vue&type=script&lang=js&"
import style0 from "./channels-listing.vue?vue&type=style&index=0&id=4fc3a3b8&scoped=true&lang=scss&"
import style1 from "./channels-listing.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc3a3b8",
  null
  
)

export default component.exports